import youcam from './youcam/routes';

export default [youcam];
